import { Component, OnInit, ErrorHandler } from '@angular/core';
//import { AdataService } from '../../shared/adata.service';
import { NgForm,Validators, FormBuilder} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';
import { VALID } from '@angular/forms/src/model';


@Component({
  selector: 'app-customer-creation',
  templateUrl: './customer-creation.component.html',
  styleUrls: ['./customer-creation.component.css']
})

export class CustomerCreationComponent implements OnInit {

  title = "Customer Creation";
  data: any={};
  branchlist: any=[];
  branchset:any={};
  customerId: any;
  c: any={};
le:any={};
lec:any={};
viewcustid:any;
lin:any={};

  arealist: any=[];
  taluklist: any=[];
  districtlist: any=[];
  statelist: any=[];
  castelist: any;
  religionlist: any=[];
  reservationlist: any=[];
  privilegelist:any=[];
  categorylist:any=[];
  occupationlist:any=[];
  educationlist: any=[];
  maritallist: any;
  designationlist: any=[];
  documentNameslist: any=[];
  today = new Date();  
  DateValues : string;
  fileToUpload: File = null;
  u:any={};
  mode: any;
  CUSTID: any;
  customerlist:any=[];
  ImageList: any=[];
  PhotoPath: any;
  dis:string;
//  mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$"; 
 emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  bloodgrouplist: any=[];
  areabasedlist: any=[];
  BRANCH_ID:any;
  photoimageUrl: string = "assets/images/image-default.png";
  signatureimageUrl: string = "assets/images/image-default.png";
  lephotoimageUrl: string = "assets/images/image-default.png";
  lesignatureimageUrl: string = "assets/images/image-default.png";
  hidin:boolean;
  savedcustid:any;
  viewgender:any;
  padd:boolean;
  radd:boolean;
  oadd:boolean;
  optOffice:boolean;
  optPer:boolean;
  ProfDocUrl: any;
  custdoclist: any;
  constitypedata: any;
  custtypelist: any;
  areabasedpmlist: any;
  areabasedoalist: any;
  pmadata: any;
  omaddata: any;
  display: string;
  leareabasedpmlist: any;
  lepmadata: any;
  leareabasedlist: any;
  ledata: any;
  desdata: any;
  deginationlist: any;
  v: any;
  legalhide:boolean;
  legalshow: boolean;
  memberdata: any;
  memberdatalist: any;
  memberindividuallist: any;
  lecustid: any;
 
  DocumentModelsList: any[];
  CustomerType: any;
  CustomerList: any;



  constructor(private service: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private datepipe: DatePipe )  
  {
    

  }

  ngOnInit() 
  {
    //mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$"; 
   // emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.GetAllAreas();
      this.CUSTID = params['CUSTID'];
      

    });
    this.viewcustid=this.CUSTID;
    this.legalhide=true;
    this.legalshow=false;
    if (this.mode == 'view') {
      this.title = "View Customer Creation";
    }
    else if (this.mode == 'edit') {
      this.title = "Edit Customer Creation";
    }

    this.hidin=true;
    this.viewgender="";
    this.BRANCH_ID=localStorage.getItem('BRANCH_ID');

   //this.GetMaxCustomerId(this.BRANCH_ID);
    this.optOffice=false;
    this.optPer=false;
    this.padd=true;
    this.radd=false;
    this.oadd=false;
    this.GetAllBranches(); 
    this.GetAllBloodgroups();
    debugger; 
    this.GetAllAreas();
    this.GetAllTaluks();
    this.GetAllDistricts();
    this.GetAllStates();
    this.GetAllCaste();
    this.GetAllReligion();
    this.GetAllReservation();
    this.GetAllReservation(); 
    this.GetAllPriveleges(); 
    this.GetAllCategory();
    this.GetAllOccupation();
    this.GetAllEducation();
    this.GetAllMartialStatusList();
    this.GetAllDesignation();
    this.GetAllDocumentNames();
    this.getdesiugnation();
    this.c.CC_OB="Indian";//nationality
    this.c.C_NAME="India";
    this.c.C_CODE ="India";
    //this.c.ST_CODE="Karnataka";


    this.DateValues = this.datepipe.transform(this.today,'dd-MM-yyyy');
    //this.c.LINKDATE=this.DateValues;
    this.c.RESI_STAT="Indian Origin";
    if (this.CUSTID != null && this.mode != null)
      this.GetCustomerDetailsById(this.CUSTID);
  }

  
  GetAllBranches() {
    debugger;
    let BRANCH_ID=localStorage.getItem('BRANCH_ID');
      this.data = this.service.getAllBranches();
      this.data.subscribe(
        (response:any) => {
          for(let i=0;i<response.length;i++){
            if(this.BRANCH_ID==response[i].BRANCH_ID){
              this.branchset= response[i];  //response;
           }
          }
          this.branchlist=Array.of(this.branchset);
          this.c.BRANCH_ID=this.BRANCH_ID;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
  }



  GetMaxCustomerId(branchId) {
    debugger;
    this.dis='Y';
   // document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getMaxCustomerId(branchId);
    this.data.subscribe(
      (response: any) => {
        debugger;
        this.customerId = response;
        console.log(this.customerId);
   
        this.savedcustid=this.customerId;
      // this.c.MANUALNO=this.customerId;
      // document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
    // }
  }


  GetAllAreas() {
    debugger;
      this.data = this.service.getAllAreas();
      this.data.subscribe(
        (response:any) => {
          this.arealist = response;
          console.log(this.arealist);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

  GetAllAreasview(aid:any) {
    debugger;
    let acode;
      this.data = this.service.getAllAreas();
      this.data.subscribe(
        (response:any) => {
          for(let i=0;i<response.length;i++){
            if(aid==response[i].BRANCH_ID){
              this.c.ANAME=response[i].ACODE;
              this.c.PMANAME= response[i].ACODE;  //response;
              this.c.OANAME=response[i].ACODE;
           }
          }
          return acode;
          //this.arealist = response;
       // }, (error) => {
        //  document.getElementById('loader-spinner').style.display = "none";
         // this.errorHandler.handleError(error);
        });
  }
  GetAllTaluks() {
    debugger;
      this.data = this.service.getAllTaluks();
      this.data.subscribe(
        (response:any) => {
          this.taluklist = response;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  GetAllDistricts() {
    debugger;
      this.data = this.service.getAllDistricts();
      this.data.subscribe(
        (response:any) => {
          this.districtlist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  GetAllStates() {
    debugger;
      this.data = this.service.getAllStates();
      this.data.subscribe(
        (response:any) => {
          this.statelist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

//caste
  GetAllCaste() {
    debugger;
      this.data = this.service.getAllCaste();
      this.data.subscribe(
        (response:any) => {
          this.castelist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  //religion
  GetAllReligion() {
    debugger;
      this.data = this.service.getAllReligion();
      this.data.subscribe(
        (response:any) => {
          this.religionlist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  //reservation
  GetAllReservation() {
    debugger;
      this.data = this.service.getAllReservation();
      this.data.subscribe(
        (response:any) => {
          this.reservationlist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

   //priviledges
   GetAllPriveleges() {
    debugger;
      this.data = this.service.getAllPriveleges();
      this.data.subscribe(
        (response:any) => {
          this.privilegelist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  //Category
  GetAllCategory() {
    debugger;
      this.data = this.service.getAllCategory();
      this.data.subscribe(
        (response:any) => {
          this.categorylist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

   //Occupation
   GetAllOccupation() {
    debugger;
      this.data = this.service.getAllOccupation();
      this.data.subscribe(
        (response:any) => {
          this.occupationlist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

   //Education
   GetAllEducation() {
    debugger;
      this.data = this.service.getAllEducation();
      this.data.subscribe(
        (response:any) => {
          this.educationlist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

   //MartialStatus
   GetAllMartialStatusList() {
    debugger;
      this.data = this.service.getAllMartialStatusList();
      this.data.subscribe(
        (response:any) => {
          this.maritallist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  //designations
  GetAllDesignation() {
    debugger;
      this.data = this.service.getAlldesignationsList();
      this.data.subscribe(
        (response:any) => {
          this.designationlist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

   //document Names
   GetAllDocumentNames() {
    debugger;
      this.data = this.service.getAlldocumentNamesList();
      this.data.subscribe(
        (response:any) => {
          this.documentNameslist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }





   onClick(event,checklike){
    debugger;
    if(checklike.checked!=true)
    {
    this.c.PMHouseNo=this.c.HouseNo1;
    this.c.PMDIS_ADD=this.c.DIS_ADD;
    this.c.PMDIS_ADD_LL=this.c.DIS_ADD_LL;
    this.c.PMANAME=this.c.ANAME;
    this.c.PMSUB_DIS_CODE=this.c.SUB_DIS_CODE;
    this.c.PMDIS_CODE=this.c.DIS_CODE;
    this.c.PMST_CODE=this.c.ST_CODE;
    this.c.PMPINCODE=this.c.PINCODE;
    this.c.pmC_CODE=this.c.C_CODE;
    this.c.PMPHONE=this.c.PHONE;
    this.c.PMMOBILE=this.c.MOBILE;
    this.optPer=true;
    }
    else if(checklike.checked==true)
    {
      this.c.PMHouseNo="";
      this.c.PMDIS_ADD="";
      this.c.PMDIS_ADD_LL="";
      this.c.PMANAME="";
      this.c.PMSUB_DIS_CODE="";
      this.c.PMDIS_CODE="";
      this.c.PMST_CODE="";
      this.c.PMPINCODE="";
        this.c.pmC_CODE="";
      this.c.PMPHONE=""
      this.c.PMMOBILE="";
      this.optPer=false;

    }
  }

  onOAClick(event,booleanVariable){
    debugger;
    if(booleanVariable.checked !=true)
    {
    this.c.OABuildingNo=this.c.HouseNo1;
    this.c.OADIS_ADD=this.c.DIS_ADD;
    this.c.OADIS_ADD_LL=this.c.DIS_ADD_LL;
    this.c.OANAME=this.c.ANAME;
    this.c.OASUB_DIS_CODE=this.c.SUB_DIS_CODE;
    this.c.OADIS_CODE=this.c.DIS_CODE;
    this.c.OAST_CODE=this.c.ST_CODE;
    this.c.OAPINCODE=this.c.PINCODE;
    this.c.OAC_CODE=this.c.C_CODE;
    this.c.OAPHONE=this.c.PHONE;
    this.c.OAMOBILE=this.c.MOBILE;
    this.c.OAEMAIL =this.c.EMAIL;
    this.optOffice=true;
    this.c.OC_NAME=this.c.C_CODE;
    }
    else if(booleanVariable.checked ==true)
    {
      this.c.OABuildingNo="";
      this.c.OADIS_ADD="";
      this.c.OADIS_ADD_LL="";
      this.c.OANAME="";
      this.c.OASUB_DIS_CODE="";
      this.c.OADIS_CODE="";
      this.c.OAST_CODE="";
      this.c.OAPINCODE="";
      this.c.OAC_CODE="";
      this.c.OAPHONE="";
      this.c.OAMOBILE="";
      this.c.OAEMAIL ="";
      this.optOffice=false;
      this.c.OC_NAME="";

    }
     }



//For Image upload
 FileInputForPhoto(file: FileList) {
      debugger;
     //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
     let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.JPG|.JPEG|.PNG)$/;
     let s: any = file.item(0).size / 1024;
     let size: any = parseFloat(s).toFixed(2);
     let uploadedFilename = file.item(0).name;
     if (uploadedFilename.match(regex) && (size <= 5048)) {
       this.fileToUpload = file.item(0);
       var reader = new FileReader();
       reader.onload = (event: any) => {
          //this.getPhotoUrl = event.target.result;
       }
       reader.readAsDataURL(this.fileToUpload);
       const data = new FormData();
       data.append("UploadedImage", file.item(0));
       let x = this.service.uploadImagecus(data);
       x.subscribe(
         (response) => {
           // console.log(response);
           // this.app.APP_PA_PhotoErrorMessage="";
   
         }, (error) => {
          // let i: any = document.getElementById('IMG_Name');
          // i.value = "";
           if (error.status == 400) {
             // this.FeasibilityPDFUrl = "assets/images/image-default.png";
             //swal('Warning!', error.error.Message, 'warning');
           }
         });
     }
    // else {
       let i: any = document.getElementById('Photo');
      // i.value = "";
      // if (!uploadedFilename.match(regex))
         //swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
      // else if (size > 2048)
         //swal('Warning!', "Please upload image file less than 2mb", 'warning');
    // }
   }
   
   
   
  getPhotoUrl() {
     let imagename = null;
     try {
       imagename = document.getElementById('Photo');
       return imagename.files[0].name;
     }
     catch (e) {
       return null;
     }
   } 

 //Signature
   FileInputForSignature(file: FileList) {
    debugger;
   //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
   let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.JPG|.JPEG|.PNG)$/;
   let s: any = file.item(0).size / 1024;
   let size: any = parseFloat(s).toFixed(2);
   let uploadedFilename = file.item(0).name;
   if (uploadedFilename.match(regex) && (size <= 5048)) {
     this.fileToUpload = file.item(0);
     var reader = new FileReader();
     reader.onload = (event: any) => {
       // this.getSignatureUrl = event.target.result;
     }
     reader.readAsDataURL(this.fileToUpload);
     const data = new FormData();
     data.append("UploadedImage", file.item(0));
     let x = this.service.uploadImagecus(data);
     x.subscribe(
       (response) => {
         // console.log(response);
         // this.app.APP_PA_PhotoErrorMessage="";
 
       }, (error) => {
        // let i: any = document.getElementById('IMG_Name');
        // i.value = "";
         if (error.status == 400) {
           // this.FeasibilityPDFUrl = "assets/images/image-default.png";
           //swal('Warning!', error.error.Message, 'warning');
         }
       });
   }
  // else {
     let i: any = document.getElementById('Photo');
    // i.value = "";
    // if (!uploadedFilename.match(regex))
       //swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
    // else if (size > 2048)
       //swal('Warning!', "Please upload image file less than 2mb", 'warning');
  // }
 }
 
 
 
 getSignatureUrl() {
   let imagename = null;
   try {
     imagename = document.getElementById('Signature');
     return imagename.files[0].name;
   }
   catch (e) {
     return null;
   }
 }

 Documents=[];
 AddDocuments(u) {
  debugger;
  if (u.CERT_ID==undefined || u.CERT_ID==null || u.LINKNO==undefined ||u.LINKDATE==null) {
    swal("Please select atleast one document");
  }
  else       
   {
    let temp = {
      CERT_ID: u.CERT_ID,
      documentName:this.GetDocumentTypeName(u.CERT_ID), 
      LINKNO: u.LINKNO,
      LINKDATE: u.LINKDATE,
      custId:0,
      profdoc:this.custdoc(),
    }
    this.Documents.push(temp);
     this.u.CERT_ID=null;
     this.u.LINKNO='';
    this.u.LINKDATE='';

   }
  }


 GetDocumentTypeName(CERT_ID)
  {
    debugger;
    for (let i = 0; i < this.documentNameslist.length; i++) {
      if (this.documentNameslist[i].CODE == CERT_ID) {
        let documentName = this.documentNameslist[i].NAME_DESC;
        return documentName;
      }
    }
  }


 



  //remove row
  RemoveDocuments(i){    
    swal({
      title: 'Are you sure?', text: "You want to Remove!", type: 'warning',
       showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
       
        if (result.value) 
        {
          this.Documents.splice(i, 1);      
        }
        else
        {

        } 
  })
    
    
  }


  //update
  UpdateCustomerDetails(customer_creation: NgForm) {
    debugger;
    if(customer_creation.value.CASTE_CODE==null||undefined)
    customer_creation.value.CASTE_CODE=1;   //1
      if(customer_creation.value.RELIGION_CODE==null||undefined)
          customer_creation.value.RELIGION_CODE=1;
      if(customer_creation.value.RES_CODE==null||undefined)
          customer_creation.value.RES_CODE=1;
      if(customer_creation.value.CUST_PRIVILEDGE==null||undefined)
          customer_creation.value.CUST_PRIVILEDGE=0;
      if(customer_creation.value.MARITALSTATUS==null||undefined)
          customer_creation.value.MARITALSTATUS=6
      if(customer_creation.value.CATG_CODE==null||undefined)
          customer_creation.value.CATG_CODE=6;
      if(customer_creation.value.OCCID==null||undefined)
          customer_creation.value.OCCID=1;
      if(customer_creation.value.ANNUALINCOME_1==null||undefined)
        customer_creation.value.ANNUALINCOME_1=0;
      if(customer_creation.value.EDUID==null||undefined)
        customer_creation.value.EDUID=1;
      if(customer_creation.value.BG==null||undefined)
        customer_creation.value.BG=1;
      if(customer_creation.value.CITY_OB==null||undefined)
        customer_creation.value.CITY_OB="-";
      if(customer_creation.value.MANUALNO==null||undefined)
        customer_creation.value.MANUALNO=0;
      if(customer_creation.value.PHONE==null||undefined)
        customer_creation.value.PHONE=0;


   // if (br.valid) {
   //   this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      customer_creation.value.Photo=this.getPhotoUrl();
      customer_creation.value.Signature=this.getSignatureUrl();
      for (let i = 0; i < this.Documents.length; i++) {
        customer_creation.value.CERT_ID=this.Documents[i].CERT_ID;
        customer_creation.value.LINKNO=this.Documents[i].LINKNO;
        customer_creation.value.LINKDATE=this.Documents[i].LINKDATE;
        customer_creation.value.CUSTID=this.Documents[i].CUSTID
      }
      customer_creation.value.DocumentModelsList= this.Documents;
      customer_creation.value.CustomerType=this.c.CUSTTYPE;
      customer_creation.value.FCODE=this.c.FCODE;
      customer_creation.value.CUSTID = this.c.CUSTID;

       //For Taluk code
       for (let i = 0; i < this.taluklist.length; i++) {
        if (this.taluklist[i].SUB_DIS_NAME == this.c.SUB_DIS_CODE) {
          let talukcode = this.taluklist[i].SUB_DIS_CODE;
          customer_creation.value.SUB_DIS_CODE=talukcode;
        }
      }

       //For Districtcode
       for (let i = 0; i < this.districtlist.length; i++) {
        if (this.districtlist[i].DIS_NAME == this.c.DIS_CODE) {
          let districtcode = this.taluklist[i].SUB_DIS_CODE;
          customer_creation.value.DIS_CODE=districtcode;
        }
      }

       //For Statecode
       for (let i = 0; i < this.statelist.length; i++) {
        if (this.statelist[i].ST_NAME == this.c.ST_CODE) {
          let statecode = this.statelist[i].ST_CODE;
          customer_creation.value.ST_CODE=statecode;
        }
      }

       //For Religioncode
       for (let i = 0; i < this.religionlist.length; i++) {
        console.log(this.religionlist,'religionlist');
        if (this.religionlist[i].RELEGION_CODE == this.c.RELIGION_CODE) {
          let religioncode = this.religionlist[i].RELEGION_CODE;
          customer_creation.value.RELIGION_CODE=religioncode;
          console.log(this.religionlist,'religionlist');
          console.log(customer_creation.value.RELIGION_CODE);
        }
      }
      
      //for customer type value
      if(this.c.CUSTTYPE=="Individual")
      {
        customer_creation.value.CUSTTYPE=4;
      }

      customer_creation.value.CUSTTYPE=4;

      if(this.c.CUSTTYPE=='Legal Entity')
      {
        customer_creation.value.CUSTTYPE=customer_creation.value.ConstitutionType;
      }
      console.log(customer_creation.value);
      this.data = this.service.updateCustomerDetails(customer_creation.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Success!', 'Updated Successfully.', 'success');
          customer_creation.reset();
          this.Documents=[];
          this.router.navigate(['/home/UnicoreMaster']);
        }, (error) => {
         document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.handleError(error);
        });
    //}
 //   else {
    //  swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
    //  this.formInvalid = true;
   // }
  }



  //Blood group dropdown

  GetAllBloodgroups() {
    debugger;
      this.data = this.service.getAllBloodgroups();
      this.data.subscribe(
        (response:any) => {
          this.bloodgrouplist = response;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
  }


  Cancel(){
    this.c=[];
    this.u.CERT_ID="";
    this.u.LINKNO="";
    this.u.LINKDATE="";
    this.Documents=[];
  }


  CalculateAge()
  {
    debugger;
    let ageofcust;
    this.DOBempty=false;
    if(this.c.DOB.length>10)
     swal('Date','Enter correct date')
    else if (this.c.DOB) {
    //convert date again to type Date
    const bdate = new Date(this.c.DOB);
    const timeDiff = Math.abs(Date.now() - bdate.getTime() );
    this.c.AGE = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    ageofcust= Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    if(ageofcust<18)
    {
      swal('Warning','Customer must be greater than 18 years old',"warning");
      this.c.DOB='';
      this.c.AGE='';
      
    }
  }

  }


  GetAllDetailsBasedOnArea(ANAME){
    debugger;
    this.ANAMEempty=false;
      this.data = this.service.getAllDetailsBasedOnArea(ANAME);
      this.data.subscribe(
        (response:any) => {
          this.areabasedlist = response;
          console.log(this.areabasedlist);
          this.c.ST_CODE=this.areabasedlist[0].ST_NAME;
          this.c.DIS_CODE =this.areabasedlist[0].DIS_NAME;
          this.c.PINCODE =this.areabasedlist[0].PINCODE;
          this.c.SUB_DIS_CODE =this.areabasedlist[0].SUB_DIS_NAME;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }



   //photo
   FileInputForPhotoNew(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.photoimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.service.uploadImagecus(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('Photo');
          //i.value="";
          if (error.status == 400) {
            this.photoimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Photo');
     // i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  //Signature
  FileInputForSignatureNew(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.signatureimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.service.uploadImagecus(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('Signature');
          //i.value="";
          if (error.status == 400) {
            this.signatureimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Signature');
     // i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }


  asetgend(CUSTTYPE:string)
  {
    //this.c.FirmType=CUSTTYPE;
    if(CUSTTYPE=="Legal Entity")
    {
      this.legalhide=false;
      this.legalshow=true;
    }
    else
    {
      this.legalhide=true;
      this.legalshow=false;
    }

  }
  
  inprescomunaddrs()
  {
    debugger;
    this.padd=true;
    this.radd=false;
    this.oadd=false;
  }
  inpermancommunaddrs()
  {
    this.padd=false;
    this.radd=true;
    this.oadd=false;
  }
  inoffcommunaddrs()
  {
    this.padd=false;
    this.radd=false;
    this.oadd=true;
  }

  selprescomunaddrs()
  {
    debugger;
    this.padd=true;
    this.radd=false;
    this.oadd=false;
  }
  selpermancommunaddrs()
  {
    this.padd=false;
    this.radd=true;
    this.oadd=false;
  }
  seloffcommunaddrs()
  {
    this.padd=false;
    this.radd=false;
    this.oadd=true;
  }

  FileInputForProfDocumnet(file: FileList) 
  {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.ProfDocUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.service.uploadProfDoccus(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('profdoc');
          //i.value="";
           if (error.status == 400) {
             this.ProfDocUrl = "assets/images/image-default.png";
             swal('Warning!', error.error.Message, 'warning');
           }
        });
    }
    else {
      let i: any = document.getElementById('profdoc');
     // i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  custdoc() {
    let imagename = null;
    try {
      imagename = document.getElementById('profdoc');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  CUSTTYPEempty:boolean=false;

  loadconstitutiontype(custtype)
  {
    debugger;
    this.CUSTTYPEempty=false;
    let type=0;
    if(custtype=='Legal Entity')
      type=2;
    else
      type=1;

      this.constitypedata=this.service.getconstitutiontype(type);
      this.constitypedata.subscribe(
        (custtyperes:any)=>
        {
          this.custtypelist=custtyperes;
          console.log(this.custtypelist);
        }
      )

  }
  GetAllDetailsBasedOnAreaforpermanentaddress(ANAME){
    debugger;
      this.pmadata = this.service.getAllDetailsBasedOnArea(ANAME);
      this.pmadata.subscribe(
        (response:any) => {
          this.areabasedpmlist = response;
          console.log(this.areabasedlist);
          this.c.PMSUB_DIS_CODE =this.areabasedpmlist[0].SUB_DIS_NAME;
          this.c.PMDIS_CODE =this.areabasedpmlist[0].DIS_NAME;
          this.c.PMST_CODE=this.areabasedpmlist[0].ST_NAME;
          
          this.c.PMPINCODE =this.areabasedpmlist[0].PINCODE;
          
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }
  GetAllDetailsBasedOnAreaforofficeaddress(ANAME){
    debugger;
      this.omaddata = this.service.getAllDetailsBasedOnArea(ANAME);
      this.omaddata.subscribe(
        (response:any) => {
          this.areabasedoalist = response;
          console.log(this.areabasedlist);
          this.c.OASUB_DIS_CODE =this.areabasedoalist[0].SUB_DIS_NAME;
          this.c.OADIS_CODE =this.areabasedoalist[0].DIS_NAME;
          this.c.OAST_CODE=this.areabasedoalist[0].ST_NAME;
          
          this.c.OAPINCODE =this.areabasedoalist[0].PINCODE;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }


  openModalDialog()
  {
    this.display='block'; //Set block css
  }
  
  closeModalDialog()
  {
    this.display='none'; //set none css after close dialog
  }
  addindividual()
  {
    this.openModalDialog();
  }


  GetDetailsBasedOnArea(ANAME){
    debugger;
      this.ledata = this.service.getAllDetailsBasedOnArea(ANAME);
      this.ledata.subscribe(
        (response:any) => {
          this.leareabasedlist = response;
          console.log(this.leareabasedlist);
          this.le.ST_CODE=this.leareabasedlist[0].ST_NAME;
          this.le.DIS_CODE =this.leareabasedlist[0].DIS_NAME;
          this.le.PINCODE =this.leareabasedlist[0].PINCODE;
          this.le.SUB_DIS_CODE =this.leareabasedlist[0].SUB_DIS_NAME;
          this.le.C_NAME="India";
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }
  GetDetailsBasedOnAreaforpermanentaddress(ANAME){
    debugger;
      this.lepmadata = this.service.getAllDetailsBasedOnArea(ANAME);
      this.lepmadata.subscribe(
        (response:any) => {
          this.leareabasedpmlist = response;
          console.log(this.leareabasedpmlist);

          debugger;
          this.le.PMSUB_DIS_CODE =this.leareabasedpmlist[0].SUB_DIS_NAME;
          this.le.PMDIS_CODE =this.leareabasedpmlist[0].DIS_NAME;
          this.le.PMST_CODE=this.leareabasedpmlist[0].ST_NAME;
          
          this.le.PMPINCODE =this.leareabasedpmlist[0].PINCODE;
          this.le.pmC_CODE='India';
          
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  INDlegal=[];
 
  cancelmem()
  {
    this.le={};
    this.le.CERT_ID="";
    this.le.LINKNO="";
    this.le.LINKDATE="";
    this.lDocuments=[];
    this.lec={};
    this.lephotoimageUrl='';
    this.lesignatureimageUrl='';
  }
legalentitySubmit(customer_creation: NgForm) 
  {
    debugger;
  if
  (customer_creation.value.CUSTTYPE==undefined || customer_creation.value.CUSNAME==undefined||null &&  
    customer_creation.value.MOTHNAME==undefined ||  customer_creation.value.HouseNo1==undefined||null &&   customer_creation.value.DIS_ADD==undefined &&    
    customer_creation.value.ANAME==undefined &&  customer_creation.value.MOBILE==undefined && customer_creation.value.EMAIL==undefined
     
    )
  {
    if(customer_creation.value.CUSTTYPE==undefined)
    this.CUSTTYPEempty=true;
if(customer_creation.value.CUSNAME==undefined||null)
   this.CUSNAMEempty=true;
if(customer_creation.value.FATHNAME==undefined||null)
  this.FATHNAMEempty=true;
if(customer_creation.value.MOTHNAME==undefined)
  this.MOTHNAMEempty=true;
if(customer_creation.value.HouseNo1==undefined||null)
  this.HouseNo1empty=true;
if(customer_creation.value.DIS_ADD==undefined)
  this.DIS_ADDempty=true;
if(customer_creation.value.ANAME==undefined)
  this.ANAMEempty=true;
if(customer_creation.value.MOBILE==undefined)
  this.MOBILEempty=true;
if(customer_creation.value.EMAIL==undefined)
  this.EMAILempty=true;
if( customer_creation.value.GENDER==undefined )
  this.GENDERempty=true;
if(customer_creation.value.DOB==undefined)
  this.DOBempty=true;
if(this.c.PINCODE==undefined)
   this.PINCODEempty=true;
    swal("Warning!", "Please enter all the Mandatory fields",'warning');
  }

  else
  {
      if(customer_creation.value.CASTE_CODE==null||undefined)
          customer_creation.value.CASTE_CODE=1;   //1
      if(customer_creation.value.RELIGION_CODE==null||undefined)
          customer_creation.value.RELIGION_CODE=1;
      if(customer_creation.value.RES_CODE==null||undefined)
          customer_creation.value.RES_CODE=1;
      if(customer_creation.value.CUST_PRIVILEDGE==null||undefined)
          customer_creation.value.CUST_PRIVILEDGE=0;
      if(customer_creation.value.MARITALSTATUS==null||undefined)
          customer_creation.value.MARITALSTATUS=6
      if(customer_creation.value.CATG_CODE==null||undefined)
          customer_creation.value.CATG_CODE=6;
      if(customer_creation.value.OCCID==null||undefined)
          customer_creation.value.OCCID=1;
      if(customer_creation.value.ANNUALINCOME_1==null||undefined)
         customer_creation.value.ANNUALINCOME_1=0;
      if(customer_creation.value.EDUID==null||undefined)
         customer_creation.value.EDUID=1;
      if(customer_creation.value.BG==null||undefined)
         customer_creation.value.BG=1;
      if(customer_creation.value.CITY_OB==null||undefined)
         customer_creation.value.CITY_OB="-";
      if(customer_creation.value.MANUALNO==null||undefined)
         customer_creation.value.MANUALNO=0;
      if(customer_creation.value.PHONE==null||undefined)
         customer_creation.value.PHONE=0;
      

         customer_creation.value.comOFCODE=this.oadd;
         customer_creation.value.comRFCODE=this.radd;
         customer_creation.value.comPFCODE=this.padd;

         customer_creation.value.optPer= this.optPer;
         customer_creation.value.optOffice= this.optOffice;
         debugger;

         if((customer_creation.value.PMHouseNo ==undefined && customer_creation.value.PMDIS_ADD==undefined && customer_creation.value.PMANAME==undefined))
            customer_creation.value.presentaddres=false;
        else
            customer_creation.value.presentaddres=true;
        if(customer_creation.value.OABuildingNo==undefined && customer_creation.value.OADIS_ADD==undefined && customer_creation.value.OANAME==undefined)
           customer_creation.value.officeaddres=false;
        else
           customer_creation.value.officeaddres=true;


      this.GetMaxCustomerId(this.BRANCH_ID);
      document.getElementById('loader-spinner').style.display = "block";
      customer_creation.value.Photo=this.getPhotoUrl();
      customer_creation.value.Signature=this.getSignatureUrl();
      for (let i = 0; i < this.Documents.length; i++) {
        customer_creation.value.CERT_ID=this.Documents[i].CERT_ID;
        customer_creation.value.LINKNO=this.Documents[i].LINKNO;
        customer_creation.value.LINKDATE=this.Documents[i].LINKDATE;
        customer_creation.value.profdoc=this.Documents[i].profdoc;
      }
    
      customer_creation.value.DocumentModelsList= this.Documents;
      customer_creation.value.CustomerType=this.c.CUSTTYPE;
      customer_creation.value.memberdetailsindividual=this.memberdetailsindividual;


      //For Taluk code
      for (let i = 0; i < this.taluklist.length; i++) {
        if (this.taluklist[i].SUB_DIS_NAME == this.c.SUB_DIS_CODE) {
          let talukcode = this.taluklist[i].SUB_DIS_CODE;
          customer_creation.value.SUB_DIS_CODE=talukcode;
        }
      }

       //For Districtcode
       for (let i = 0; i < this.districtlist.length; i++) {
        if (this.districtlist[i].DIS_NAME == this.c.DIS_CODE) {
          let districtcode = this.taluklist[i].SUB_DIS_CODE;
          customer_creation.value.DIS_CODE=districtcode;
        }
      }
       //For Statecode
       for (let i = 0; i < this.statelist.length; i++) {
        if (this.statelist[i].ST_NAME == this.c.ST_CODE) {
          let statecode = this.statelist[i].ST_CODE;
          customer_creation.value.ST_CODE=statecode;
        }
      }
      if(this.c.CUSTTYPE=="Individual")
      {
        customer_creation.value.CUSTTYPE=4;
      }

      if(this.c.CUSTTYPE=='Legal Entity')
      {
        customer_creation.value.CUSTTYPE=customer_creation.value.ConstitutionType;
        console.log("legalentity");
        console.log(this.INDlegal);
        customer_creation.value.legalentity=this.INDlegal;
        console.log("Customer");
        console.log(customer_creation.value.legalentity);
      }
      this.data = this.service.SaveCustomerDetails(customer_creation.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Success!', 'Customer Saved Successfully with ID:'+this.savedcustid, 'success');
          customer_creation.reset();
          this.Documents=[];
          this.router.navigate(['/home/UnicoreMaster']);
        }, (error) => {
          if(error.status==401)
          {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.handleError(error);
            console.log(error);
          }
          else if(error.status==400)
          {
            document.getElementById('loader-spinner').style.display = "none";
            swal('Error!','Not Found!!!','error');
          }
          else
          {
            document.getElementById('loader-spinner').style.display = "none";
            swal('Error! Something went wrong','Error:'+error,'error');
          }
        });



   // }
  //  else 
   // {
   //   document.getElementById('loader-spinner').style.display = "none";
   //   swal('Warning!', 'Please enter the details', 'warning');
   // }
      }
  }
 
  getdesiugnation()
  {
    this.desdata=this.service.GetDesignation();
    this.desdata.subscribe(
      (desresponse:any)=>
      {
        this.deginationlist=desresponse;
        console.log(this.deginationlist);
      }
    )
  }

  onClickfrlegal(event,checklike){
    debugger;
    if(checklike.checked!=true)
    {
    this.le.PMHouseNo=this.le.HouseNo1;
    this.le.PMDIS_ADD=this.le.DIS_ADD;
    this.le.PMDIS_ADD_LL=this.le.DIS_ADD_LL;
    this.le.PMANAME=this.le.ANAME;
    this.le.PMSUB_DIS_CODE=this.le.SUB_DIS_CODE;
    this.le.PMDIS_CODE=this.le.DIS_CODE;
    this.le.PMST_CODE=this.le.ST_CODE;
    this.le.PMPINCODE=this.le.PINCODE;
    this.le.pmC_CODE=this.le.C_CODE;
    this.le.PMPHONE=this.le.PHONE;
    this.le.PMMOBILE=this.le.MOBILE;
    this.optPer=true;
    }
    else if(checklike.checked==true)
    {
      this.le.PMHouseNo="";
      this.le.PMDIS_ADD="";
      this.le.PMDIS_ADD_LL="";
      this.le.PMANAME="";
      this.le.PMSUB_DIS_CODE="";
      this.le.PMDIS_CODE="";
      this.le.PMST_CODE="";
      this.le.PMPINCODE="";
        this.le.pmC_CODE="";
      this.le.PMPHONE=""
      this.le.PMMOBILE="";
      this.optPer=false;

    }
  }
  settype(ConstitutionType)
  {
    for(let i=0; i<=this.custtypelist.length;i++)
    {
      if(ConstitutionType==this.custtypelist[i].code)
       {
         this.le.type=this.custtypelist[i].Name;
       } 
    }

  }

  FileInputForProfDocumnetlegalind(file: FileList) 
  {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;

    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.ProfDocUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.service.uploadProfDoccus(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('leprofdoc');
          //i.value="";
           if (error.status == 400) {
             this.ProfDocUrl = "assets/images/image-default.png";
             swal('Warning!', error.error.Message, 'warning');
           }
        });
    }
    else {
      let i: any = document.getElementById('leprofdoc');
     // i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

    //Signature
    FileInputForSignaturelegal(file: FileList) {
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 2048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.lesignatureimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.service.uploadImagecus(data);
        x.subscribe(
          (response) => {
            //console.log(response);
          }, (error) => {
            let i:any=document.getElementById('leSignature');
            //i.value="";
            if (error.status == 400) {
              this.lesignatureimageUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('leSignature');
       // i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload image file with extension jpg, jpeg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }

   //photo
   FileInputForPhotolegal(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.lephotoimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.service.uploadImagecus(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('lePhoto');
          //i.value="";
          if (error.status == 400) {
            this.lephotoimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('lePhoto');
     // i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  custdoclegal() {
    let imagename = null;
    try {
      imagename = document.getElementById('leprofdoc');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  
 getSignatureUrllegal() {
  let imagename = null;
  try {
    imagename = document.getElementById('leSignature');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

lDocuments=[];
AddDocumentslegal(v) {
 debugger;
 if (v.CERT_ID==undefined || v.CERT_ID==null || v.LINKNO==undefined ||v.LINKDATE==null) {
   swal("Please select atleast one document");
 }
 else       
  {
   let temp = {
     CERT_ID: v.CERT_ID,
     documentName:this.GetDocumentTypeName(v.CERT_ID), 
     LINKNO: v.LINKNO,
     LINKDATE: v.LINKDATE,
     custId:0,
     profdoc:this.custdoclegal(),
   }
   this.lDocuments.push(temp);
    this.lec.CERT_ID=null;
    this.lec.LINKNO='';
   this.lec.LINKDATE='';

  }
 }
 getPhotoUrllegal() {
  let imagename = null;
  try {
    imagename = document.getElementById('lePhoto');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

GetCustomerDetailsById(Cust_Id) {
  
  if (Cust_Id != undefined) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getCustomerDetailsById(Cust_Id);
    this.data.subscribe(
      (response) => {
        debugger;
        if(response.CustomerType=='INDIVIDUAL')
        {
          debugger;
          this.c = response;
          console.log(response);
          //DOB
          if(response.DOB!=null)
          this.c.DOB=((response.DOB).split('T'))[0];
          if(response.CustomerType!=null)
          console.log(response.CustomerType);
          this.c.CUSTTYPE=response.CustomerType;
          this.c.ANAME=this.GetAllAreasview(response.ANAME);
          this.c.ST_CODE=response.ST_NAME;
          this.c.SUB_DIS_NAME=response.SUB_DIS_NAME;
          this.c.DIS_CODE=response.DIS_NAME;
          this.c.SUB_DIS_CODE=response.SUB_DIS_NAME;
          this.c.CC_OB="Indian";
          this.c.CITY_OB="-";
          this.c.C_CODE="India";
          this.Documents=response.DocumentModelsList;
          console.log("documnetlist");
          console.log(this.Documents);
          this.ImageList=response.ImagesList;
          this.c.C_NAME ="India";
  
         
          this.c.PMHouseNo=response.HouseNo1;
          this.c.PMDIS_ADD=response.DIS_ADD;
          this.c.PMDIS_ADD_LL=response.DIS_ADD_LL;
          this.c.PMANAME=this.GetAllAreasview(response.ANAME);
          this.c.PMSUB_DIS_CODE=response.SUB_DIS_CODE;
          this.c.PMDIS_CODE=response.DIS_CODE;
          this.c.PMST_CODE= response.ST_CODE;
          this.c.PMPINCODE= response.PINCODE;
          this.c.PMPHONE = response.PHONE;
          this.c.PMMOBILE = response.MOBILE;
          this.c.pmC_CODE=response.C_NAME;
      
          this.c.OABuildingNo=response.HouseNo1;
            this.c.OADIS_ADD =response.DIS_ADD;
            this.c.OADIS_ADD_LL=response.DIS_ADD_LL;
            this.c.OANAME =this.GetAllAreasview(response.ANAME);
            this.c.OASUB_DIS_CODE =response.SUB_DIS_CODE;
            this.c.OADIS_CODE =response.DIS_CODE;
            this.c.OAST_CODE = response.ST_CODE;
            this.c.OAPINCODE = response.PINCODE;
            this.c.OAPHONE = response.PHONE;
            this.c.OAMOBILE= response.MOBILE;
            this.c.OAEMAIL= response.EMAIL;
            this.c.OC_NAME=response.C_NAME;
  
            if(response.CASTE_CODE==1)
              this.c.CASTE_CODE='';
            if(response.RELIGION_CODE==1)
              this.c.RELIGION_CODE='';
            if(response.RES_CODE==1)
              this.c.RES_CODE='';
            if(response.CUST_PRIVILEDGE==0)
              this.c.CUST_PRIVILEDGE='';
            if(response.MARITALSTATUS==6)
              this.c.MARITALSTATUS='';
            if(response.CATG_CODE==6)
              this.c.CATG_CODE='';
            if(response.OCCID==1)
              this.c.OCCID='';
            if(response.EDUID==1)
              this.c.EDUID='';
            if(response.RESI_STAT==0)
              this.c.RESI_STAT='';
            if(response.BG==1)
              this.c.BG='';
             
            
       
           if(response.GENDER==0)
              this.viewgender="Male";
          else if(response.GENDER==1)
              this.viewgender="Female";
  //c
          if(response.MFCODE==response.PFCODE)
          {
            this.padd=true;
            this.radd=false;
            this.oadd=false;
          }
          else if(response.MFCODE==response.RFCODE)  
          {
            this.padd=false;
            this.radd=true;
            this.oadd=false;
             //Permanent address
         
          }  
          else if(response.MFCODE==response.OFCODE)      //Office Address
          {
            this.padd=false;
            this.radd=false;
            this.oadd=true;
            
          }

          //end
  
          // if(response.comPFCODE=='True')
          // {
          //   this.c.comPFCODE="PA";
          //   //this.padd=true;
          // }
          // else if(response.comRFCODE=='True')
          // {
          //   this.c.comPFCODE="PMA";
          //   //this.radd=true;
          // }
          // else if(response.comOFCODE=='True')
          // {
          //   this.c.comPFCODE="OA";
          //   //this.oadd=true;
          // }
          // else {
          //   this.c.comPFCODE="PA";
          //   //this.padd=true;
          // }
  
        // debugger;
        //   this.c.GENDER = this.fb.group({
        //     gender: [response.gender] // Pass the name value in form control array.
        //   })
        
           //For Religion code
           for (let i = 0; i < this.religionlist.length; i++) {
            if (this.religionlist[i].RELEGION_CODE == response.RELIGION_CODE) {
              let religioncode = this.religionlist[i].RELEGION_CODE;
                this.c.RELEGION_CODE=religioncode;
            }
          }
          
          this.photoimageUrl=this.ImageList.length==0?"":this.ImageList[0].PhotoPath;
          this.signatureimageUrl =this.ImageList.length==0?"":this.ImageList[1].SignaturePath;
          this.custdoclist=this.Documents[0].docpath
  
          if(response.CUSTTYPE==4)
          {
            this.c.CUSTTYPE='Individual';
          }
              //firm type
          this.c.FirmType=response.CustomerType;
          // if(response.CustomerType!=4)
          // {
          //   this.c.CUSTTYPE='Legal Entity';
          // }
  
          // for(let i=0;i<this.ImageList.length;i++)
          // {
          //   if(this.ImageList[i].IMG_Type=0)
           // this.c.PhotoPath=this.ImageList[0].PhotoPath;
           // console.log(this.c.PhotoPath);
           // this.c.Signature =this.ImageList[1].SignaturePath;
        //}
          //this.customerlist = response.Client_Projectlist;
          document.getElementById('loader-spinner').style.display = "none";
        }
        else
        {
          this.forbindinglegalentity(response);
          document.getElementById('loader-spinner').style.display = "none";
        }

      }, 
      (error) => {
        if(error.status==401)
        {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
          console.log(error);
        }
        else
        {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Error! Something went wrong','Error:'+error,'error');
        }
      });
  }
}

forbindinglegalentity(custres)
{
  debugger;
  console.log(custres);
  this.legalhide=false;
  this.legalshow=true;
  this.c = custres;
  this.c.ANAME=this.GetAllAreasviewle(custres.ANAME);
  this.c.ST_CODE=custres.ST_NAME;
  this.c.SUB_DIS_NAME=custres.SUB_DIS_NAME;
  this.c.DIS_CODE=custres.DIS_NAME;
  this.c.SUB_DIS_CODE=custres.SUB_DIS_NAME;
  this.c.CC_OB="Indian";
  this.Documents=custres.DocumentModelsList;
  this.c.ConstitutionType=custres.CustomerType;

    this.loadconstitutiontypefrview('Legal Entity',custres.CustomerType);
    this.c.CustomerType='Legal Entity'; 
   
 // this.ImageList=custres.ImagesList;

         // this.photoimageUrl=this.ImageList.length==0?"":this.ImageList[0].PhotoPath;
         // this.signatureimageUrl =this.ImageList.length==0?"":this.ImageList[1].SignaturePath;
          this.custdoclist= this.Documents.length==0?"": this.Documents[0].docpath;
         this.memberindividuallist=custres.memberdetailsindividual;
}

 
 getmemberdetails()
 {
   this.memberdata=this.service.getmemberdetails(this.viewcustid);
   this.memberdata.subscribe(
     (memresponse:any)=>
     {
       this.memberdatalist=memresponse;
     }
   )
 }

 GetmemberDetailsById(Cust_Id,designation) 
 {
  this.getdesiugnation()
  if (Cust_Id != undefined) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getCustomerDetailsById(Cust_Id);
    this.data.subscribe(
      (response) => {
        console.log("memberdetails");
          debugger;
          this.lecustid=Cust_Id;
          this.le = response;
          for(let i=0;i<this.deginationlist.length;i++)
          {
            if(designation==this.deginationlist[i].NAME_DESC)
            {
              this.le.designation=this.deginationlist[i].CODE;
            }
          }
          //this.le.designation=designation;
          //DOB

          if(response.DOB!=null)
          this.le.DOB=((response.DOB).split('T'))[0];
          if(response.CustomerType!=null)
          console.log(response.CustomerType);
          this.le.CUSTTYPE=response.CustomerType;
          this.le.ANAME=this.GetAllAreasviewlein(response.ANAME);
          this.le.ST_CODE=response.ST_NAME;
          this.le.SUB_DIS_NAME=response.SUB_DIS_NAME;
          this.le.DIS_CODE=response.DIS_NAME;
          this.le.SUB_DIS_CODE=response.SUB_DIS_NAME;
          this.le.CC_OB="Indian";
          this.le.CITY_OB="-";
          this.le.C_CODE="India";
          //////////
       
          //////////
          this.le.C_NAME ="India";
  
         
          this.le.PMHouseNo=response.HouseNo1;
          this.le.PMDIS_ADD=response.DIS_ADD;
          this.le.PMDIS_ADD_LL=response.DIS_ADD_LL;
          this.le.PMANAME=this.GetAllAreasviewlein(response.ANAME);
          this.le.PMSUB_DIS_CODE=response.SUB_DIS_CODE;
          this.le.PMDIS_CODE=response.DIS_CODE;
          this.le.PMST_CODE= response.ST_CODE;
          this.le.PMPINCODE= response.PINCODE;
          this.le.PMPHONE = response.PHONE;
          this.le.PMMOBILE = response.MOBILE;
          this.le.pmC_CODE=response.C_NAME;
      
            if(response.CASTE_CODE==1)
              this.le.CASTE_CODE='';
            if(response.RELIGION_CODE==1)
              this.le.RELIGION_CODE='';
            if(response.RES_CODE==1)
              this.le.RES_CODE='';
            if(response.CUST_PRIVILEDGE==0)
              this.le.CUST_PRIVILEDGE='';
            if(response.MARITALSTATUS==6)
              this.le.MARITALSTATUS='';
            if(response.CATG_CODE==6)
              this.le.CATG_CODE='';
            if(response.OCCID==1)
              this.le.OCCID='';
            if(response.EDUID==1)
              this.le.EDUID='';
            if(response.RESI_STAT==0)
              this.le.RESI_STAT='';
            if(response.BG==1)
              this.le.BG='';
             
           if(response.GENDER==0)
              this.viewgender="Male";
          else if(response.GENDER==1)
              this.viewgender="Female";
  
          if(response.MFCODE==response.PFCODE)
          {
            this.padd=true;
            this.radd=false;
            this.oadd=false;
          }
          else if(response.MFCODE==response.RFCODE)  
          {
            this.padd=false;
            this.radd=true;
            this.oadd=false;
             //Permanent address
         
          }  
          else if(response.MFCODE==response.OFCODE)      //Office Address
          {
            this.padd=false;
            this.radd=false;
            this.oadd=true;
            
          }
        
           //For Religion code
           for (let i = 0; i < this.religionlist.length; i++) {
            if (this.religionlist[i].RELEGION_CODE == response.RELIGION_CODE) {
              let religioncode = this.religionlist[i].RELEGION_CODE;
                this.le.RELEGION_CODE=religioncode;
            }
          }
          this.lDocuments=response.DocumentModelsList;
          console.log("documnetlist");
          console.log(this.lDocuments);
          this.ImageList=response.ImagesList;
          
          this.lephotoimageUrl=this.ImageList.length==0?"":this.ImageList[0].PhotoPath;
          this.lesignatureimageUrl =this.ImageList.length==0?"":this.ImageList[1].SignaturePath;
          this.custdoclist=this.lDocuments[0].docpath
  
          if(response.CUSTTYPE==4)
          {
            this.c.CUSTTYPE='Individual';
          }
              //firm type
          this.le.FirmType=response.CustomerType;

          document.getElementById('loader-spinner').style.display = "none";
      }, 
      (error) => {
        if(error.status==401)
        {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
          console.log(error);
        }
        else
        {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Error! Something went wrong','Error:'+error,'error');
        }
      });
  }
  document.getElementById('loader-spinner').style.display = "none";
}
 
legalCalculateAge()
{
  debugger;
  let ageofcust;
  if(this.le.DOB.length>10)
   swal('Date','Enter correct date','warning')
  else if (this.le.DOB) {
  //convert date again to type Date
  const bdate = new Date(this.le.DOB);
  const timeDiff = Math.abs(Date.now() - bdate.getTime() );
  this.le.AGE = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  ageofcust= Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  if(ageofcust<18)
  {
    swal('Warning','Customer must be greater than 18 years old',"warning");
    this.c.DOB='';
    this.c.AGE='';
    
  }
}

}
GetAllAreasviewle(aid:any) {
  let acode;
    this.data = this.service.getAllAreas();
    this.data.subscribe(
      (response:any) => {
        debugger;
        for(let i=0;i<response.length;i++){
          if(aid==response[i].ANAME){
            this.c.ANAME=response[i].ACODE;
            this.le.PMANAME= response[i].ACODE;  //response;
            this.le.OANAME=response[i].ACODE;
           // this.c.PMANAME= response[i].ACODE;  //response;
            //this.c.OANAME=response[i].ACODE;
         }
        }
        return acode;
        //this.arealist = response;
     // }, (error) => {
      //  document.getElementById('loader-spinner').style.display = "none";
       // this.errorHandler.handleError(error);
      });
}
GetAllAreasviewlein(aid:any) {
  let acode;
    this.data = this.service.getAllAreas();
    this.data.subscribe(
      (response:any) => {
        debugger;
        for(let i=0;i<response.length;i++){
          if(aid==response[i].ANAME){
            this.le.ANAME=response[i].ACODE;
            this.le.PMANAME= response[i].ACODE;  //response;
            this.le.OANAME=response[i].ACODE;
         }
        }
        return acode;
        //this.arealist = response;
     // }, (error) => {
      //  document.getElementById('loader-spinner').style.display = "none";
       // this.errorHandler.handleError(error);
      });
}
loadconstitutiontypefrview(custtype,constitype)
{
  debugger;
  let type=0;
  if(custtype=='Legal Entity')
    type=2;
  else
    type=1;

    this.constitypedata=this.service.getconstitutiontype(type);
    this.constitypedata.subscribe(
      (custtyperes:any)=>
      {
        this.custtypelist=custtyperes;
        for(let i=0;i<this.custtypelist.length;i++)
        {
          if(constitype==this.custtypelist[i].Name)
             this.c.ConstitutionType=this.custtypelist[i].code;
        }
        
      }
    )

}

memberdetailsindividual=[];
custidempty:boolean=false;
custnameempty:boolean=false;
designationempty:boolean=false;

membernamefilled()
{
  this.custnameempty=false;
}
designationfilled()
{
  this.designationempty=false;
}
 addlinkmember(link)
 {
   if(link.custid==undefined||null ||link.custname==undefined||null)
   {
    if(link.custid==undefined||null)
      this.custidempty=true;
    if(link.custname==undefined||null)
      this.custnameempty=true;
    swal('Required','Enter the Customer Id and select to add member','warning');
    
   }
     
  else if(link.designation==undefined||null)
  {
    this.designationempty=true;
    swal('Designation','Select the designation of the member','warning');
  }
   
   else
   {

     let temp={
      BEN_CUSTID:link.custid,
      BEN_NAME:link.custname,
      NAME_DESC:this.fordesignationname(link.designation),
      designationid:link.designation

     }
    this.memberdetailsindividual.push(temp);
      this.lin.custid="";
      this.lin.custname="";
      this.lin.designation="";
      
   }
  
  
 }
 fordesignationname(id)
 {
   debugger;
    for(let i=0;i<this.deginationlist.length;i++)
    {
      if(id==this.deginationlist[i].CODE)
      {
        debugger;
        return this.designationlist[i].NAME_DESC;
      }
    }
 }
 getcustdet()
 {
  this.getdesiugnation()
 }

 RemoveMember(i)
 {    
  swal({
    title: 'Are you sure?', text: "You want to Remove!", type: 'warning',
     showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
     
      if (result.value) 
      {
        this.memberdetailsindividual.splice(i, 1);      
      }
      else
      {

      } 
     })
 }

 GetCustomerDetails(CustId)
 {
  this.data = this.service.GetAllCustomerIdDetailsforSpeedSearch(CustId);
  this.data.subscribe(
       (response: any) => {         
        this.CustomerList= response;  
        this.custidempty=false;
        console.log('Speed search');
        console.log(this.CustomerList);
     })

 }
 GetCustomerDetailsBy(CustId,CusName){
 
  this.lin.custid = CustId;
 //var list = this.CustomerList.filter(a => a.CUSTID == CustId);   
  this.lin.custname = CusName;

  this.GetCustomerDetails(null);
  
  }

savecustomer(customer_creation: NgForm) 
{
  debugger;
  if(customer_creation.value.CUSTTYPE=="Individual")
  {
    this.onSubmit(customer_creation);
  }
  else if(customer_creation.value.CUSTTYPE=="Legal Entity")
  {
    this.legalentitySubmit(customer_creation); 
  }
  else
  {
    if(customer_creation.value.CUSTTYPE==undefined)
    this.CUSTTYPEempty=true;
if(customer_creation.value.CUSNAME==undefined||null)
   this.CUSNAMEempty=true;
if(customer_creation.value.FATHNAME==undefined||null)
  this.FATHNAMEempty=true;
if(customer_creation.value.MOTHNAME==undefined)
  this.MOTHNAMEempty=true;
if(customer_creation.value.HouseNo1==undefined||null)
  this.HouseNo1empty=true;
if(customer_creation.value.DIS_ADD==undefined)
  this.DIS_ADDempty=true;
if(customer_creation.value.ANAME==undefined)
  this.ANAMEempty=true;
if(customer_creation.value.MOBILE==undefined)
  this.MOBILEempty=true;
if(customer_creation.value.EMAIL==undefined)
  this.EMAILempty=true;
if( customer_creation.value.GENDER==undefined )
  this.GENDERempty=true;
if(customer_creation.value.DOB==undefined)
  this.DOBempty=true;
    swal("Warning!", "Please enter all the Mandatory fields",'warning');
  }
}

custnamefilled()
{
  this.CUSNAMEempty=false;
}
fathnamerfiled()
{
  this.FATHNAMEempty=false;
}
Mothnamefilled()
{
  this.MOTHNAMEempty=false;
}
HouseNo1filled()
{
  this.HouseNo1empty=false;
}
DIS_ADDfilled()
{
  this.DIS_ADDempty=false;
}
// ANAMEfilled()
// {
//   this.ANAMEempty=false;
// }
MOBILEfilled()
{
  this.MOBILEempty=false;
}
EMAILfilled()
{
  this.EMAILempty=false;
}
GENDERfilled()
{
  this.GENDERempty=false;
}
// DOBfilled()
// {
//   this.DOBempty=false;
// }
PINCODEfilled()
{
  this.PINCODEempty=false;
}

CUSNAMEempty:boolean=false
FATHNAMEempty:boolean=false
MOTHNAMEempty:boolean=false
HouseNo1empty:boolean=false
DIS_ADDempty:boolean=false
ANAMEempty:boolean=false
MOBILEempty:boolean=false
EMAILempty:boolean=false
GENDERempty:boolean=false
DOBempty:boolean=false
PINCODEempty:boolean=false

onSubmit(customer_creation: NgForm) {
  debugger;
if
(customer_creation.value.CUSTTYPE==undefined || customer_creation.value.CUSNAME==undefined||null ||  customer_creation.value.FATHNAME==undefined||null || 
  customer_creation.value.MOTHNAME==undefined ||  customer_creation.value.HouseNo1==undefined||null ||   customer_creation.value.DIS_ADD==undefined ||
  customer_creation.value.ANAME==undefined ||  customer_creation.value.MOBILE==undefined || customer_creation.value.EMAIL==undefined ||
  customer_creation.value.GENDER==undefined ||  customer_creation.value.DOB==undefined
  )
{
  if(customer_creation.value.CUSTTYPE==undefined)
      this.CUSTTYPEempty=true;
  if(customer_creation.value.CUSNAME==undefined||null)
     this.CUSNAMEempty=true;
  if(customer_creation.value.FATHNAME==undefined||null)
    this.FATHNAMEempty=true;
  if(customer_creation.value.MOTHNAME==undefined)
    this.MOTHNAMEempty=true;
  if(customer_creation.value.HouseNo1==undefined||null)
    this.HouseNo1empty=true;
  if(customer_creation.value.DIS_ADD==undefined)
    this.DIS_ADDempty=true;
  if(customer_creation.value.ANAME==undefined)
    this.ANAMEempty=true;
  if(customer_creation.value.MOBILE==undefined)
    this.MOBILEempty=true;
  if(customer_creation.value.EMAIL==undefined)
    this.EMAILempty=true;
  if( customer_creation.value.GENDER==undefined )
    this.GENDERempty=true;
  if(customer_creation.value.DOB==undefined)
    this.DOBempty=true;
  if(this.c.PINCODE==undefined)
     this.PINCODEempty=true;
  swal("Warning!", "Please enter all the Mandatory fields",'warning');
}

else
{

// if (NgForm==VALID) 
//  {
    if(customer_creation.value.CASTE_CODE==null||undefined)
        customer_creation.value.CASTE_CODE=1;   //1
    if(customer_creation.value.RELIGION_CODE==null||undefined)
        customer_creation.value.RELIGION_CODE=1;
    if(customer_creation.value.RES_CODE==null||undefined)
        customer_creation.value.RES_CODE=1;
    if(customer_creation.value.CUST_PRIVILEDGE==null||undefined)
        customer_creation.value.CUST_PRIVILEDGE=0;
    if(customer_creation.value.MARITALSTATUS==null||undefined)
        customer_creation.value.MARITALSTATUS=6
    if(customer_creation.value.CATG_CODE==null||undefined)
        customer_creation.value.CATG_CODE=6;
    if(customer_creation.value.OCCID==null||undefined)
        customer_creation.value.OCCID=1;
    if(customer_creation.value.ANNUALINCOME_1==null||undefined)
       customer_creation.value.ANNUALINCOME_1=0;
    if(customer_creation.value.EDUID==null||undefined)
       customer_creation.value.EDUID=1;
    if(customer_creation.value.BG==null||undefined)
       customer_creation.value.BG=1;
    if(customer_creation.value.CITY_OB==null||undefined)
       customer_creation.value.CITY_OB="-";
    if(customer_creation.value.MANUALNO==null||undefined)
       customer_creation.value.MANUALNO=0;
    if(customer_creation.value.PHONE==null||undefined)
       customer_creation.value.PHONE=0;
    

       customer_creation.value.comOFCODE=this.oadd;
       customer_creation.value.comRFCODE=this.radd;
       customer_creation.value.comPFCODE=this.padd;

       customer_creation.value.optPer= this.optPer;
       customer_creation.value.optOffice= this.optOffice;
       debugger;

       if((customer_creation.value.PMHouseNo ==undefined && customer_creation.value.PMDIS_ADD==undefined && customer_creation.value.PMANAME==undefined))
          customer_creation.value.presentaddres=false;
      else
          customer_creation.value.presentaddres=true;
      if(customer_creation.value.OABuildingNo==undefined && customer_creation.value.OADIS_ADD==undefined && customer_creation.value.OANAME==undefined)
         customer_creation.value.officeaddres=false;
      else
         customer_creation.value.officeaddres=true;


    this.GetMaxCustomerId(this.BRANCH_ID);
    document.getElementById('loader-spinner').style.display = "block";
    customer_creation.value.Photo=this.getPhotoUrl();
    customer_creation.value.Signature=this.getSignatureUrl();
    for (let i = 0; i < this.Documents.length; i++) {
      customer_creation.value.CERT_ID=this.Documents[i].CERT_ID;
      customer_creation.value.LINKNO=this.Documents[i].LINKNO;
      customer_creation.value.LINKDATE=this.Documents[i].LINKDATE;
      customer_creation.value.profdoc=this.Documents[i].profdoc;
    }
  
    customer_creation.value.DocumentModelsList= this.Documents;
    customer_creation.value.CustomerType=this.c.CUSTTYPE;


    //For Taluk code
    for (let i = 0; i < this.taluklist.length; i++) {
      if (this.taluklist[i].SUB_DIS_NAME == this.c.SUB_DIS_CODE) {
        let talukcode = this.taluklist[i].SUB_DIS_CODE;
        customer_creation.value.SUB_DIS_CODE=talukcode;
      }
    }

     //For Districtcode
     for (let i = 0; i < this.districtlist.length; i++) {
      if (this.districtlist[i].DIS_NAME == this.c.DIS_CODE) {
        let districtcode = this.taluklist[i].SUB_DIS_CODE;
        customer_creation.value.DIS_CODE=districtcode;
      }
    }
     //For Statecode
     for (let i = 0; i < this.statelist.length; i++) {
      if (this.statelist[i].ST_NAME == this.c.ST_CODE) {
        let statecode = this.statelist[i].ST_CODE;
        customer_creation.value.ST_CODE=statecode;
      }
    }
    if(this.c.CUSTTYPE=="Individual")
    {
      customer_creation.value.CUSTTYPE=4;
    }

    if(this.c.CUSTTYPE=='Legal Entity')
    {
      customer_creation.value.CUSTTYPE=customer_creation.value.ConstitutionType;
      customer_creation.value.legalentity=this.INDlegal;
      console.log(customer_creation.value.legalentity);
    }
    this.data = this.service.SaveCustomerDetails(customer_creation.value);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('Success!', 'Customer Saved Successfully with ID:'+this.savedcustid, 'success');
        customer_creation.reset();
        this.Documents=[];
        this.router.navigate(['/home/UnicoreMaster']);
      }, (error) => {
        if(error.status==401)
        {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
          console.log(error);
        }
        else if(error.status==400)
        {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Error!','Not Found!!!','error');
        }
        else
        {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Error! Something went wrong','Error:'+error,'error');
        }
      });



 // }
//  else 
 // {
 //   document.getElementById('loader-spinner').style.display = "none";
 //   swal('Warning!', 'Please enter the details', 'warning');
 // }
    }
}


lecustnamefilled()
{
  this.leCUSNAMEempty=false;
}
lefathnamerfiled()
{
  this.leFATHNAMEempty=false;
}
leMothnamefilled()
{
  this.leMOTHNAMEempty=false;
}
leHouseNo1filled()
{
  this.leHouseNo1empty=false;
}
leDIS_ADDfilled()
{
  this.leDIS_ADDempty=false;
}
// ANAMEfilled()
// {
//   this.ANAMEempty=false;
// }
leMOBILEfilled()
{
  this.leMOBILEempty=false;
}
leEMAILfilled()
{
  this.leEMAILempty=false;
}
leGENDERfilled()
{
  this.leGENDERempty=false;
}
 DOBfilled()
 {
  this.leDOBempty=false;
 }
lePINCODEfilled()
{
  this.lePINCODEempty=false;
}
ledesignationfilled()
{
  this.ledesignationempty=false;
}
leCUSTTYPEempty:boolean=false
leCUSNAMEempty:boolean=false
leFATHNAMEempty:boolean=false
leMOTHNAMEempty:boolean=false
leHouseNo1empty:boolean=false
leDIS_ADDempty:boolean=false
leANAMEempty:boolean=false
leMOBILEempty:boolean=false
leEMAILempty:boolean=false
leGENDERempty:boolean=false
leDOBempty:boolean=false
lePINCODEempty:boolean=false
ledesignationempty:boolean=false

Saveindividual(le)
{
  //le.CUSTTYPE==undefined ||
  if
( le.CUSNAME==undefined||null ||  le.FATHNAME==undefined||null || 
  le.MOTHNAME==undefined ||  le.HouseNo1==undefined||null ||   le.DIS_ADD==undefined ||
  le.ANAME==undefined ||  le.MOBILE==undefined || le.EMAIL==undefined ||
  le.GENDER==undefined || le.DOB==undefined
  )
{
  // if(le.CUSTTYPE==undefined)
  //     this.leCUSTTYPEempty=true;
  if(le.CUSNAME==undefined||null)
     this.leCUSNAMEempty=true;
  if(le.designation==undefined||null)
     this.ledesignationempty=true;
  if(le.FATHNAME==undefined||null)
    this.leFATHNAMEempty=true;
  if(le.MOTHNAME==undefined)
    this.leMOTHNAMEempty=true;
  if(le.HouseNo1==undefined||null)
    this.leHouseNo1empty=true;
  if(le.DIS_ADD==undefined)
    this.leDIS_ADDempty=true;
  if(le.ANAME==undefined)
    this.leANAMEempty=true;
  if(le.MOBILE==undefined)
    this.leMOBILEempty=true;
  if(le.EMAIL==undefined)
    this.leEMAILempty=true;
  if( le.GENDER==undefined )
    this.leGENDERempty=true;
  if(le.DOB==undefined)
    this.leDOBempty=true;
  if(this.c.PINCODE==undefined)
     this.lePINCODEempty=true;
  swal("Warning!", "Please enter all the Mandatory fields",'warning');
}
  console.log(le);
         //for present For Taluk code
         for (let i = 0; i < this.taluklist.length; i++)
        {
          if (this.taluklist[i].SUB_DIS_NAME == this.le.SUB_DIS_CODE) {
            let talukcode = this.taluklist[i].SUB_DIS_CODE;
            le.SUB_DIS_CODE=talukcode;
          }
        }
         //For Districtcode
         for (let i = 0; i < this.districtlist.length; i++) {
          if (this.districtlist[i].DIS_NAME == this.le.DIS_CODE) {
            let districtcode = this.taluklist[i].SUB_DIS_CODE;
            le.DIS_CODE=districtcode;
          }
        }
         //For Statecode
         for (let i = 0; i < this.statelist.length; i++) {
          if (this.statelist[i].ST_NAME == this.le.ST_CODE) {
            let statecode = this.statelist[i].ST_CODE;
            le.ST_CODE=statecode;
          }
        }
        le.C_CODE=1;

         //for permannet
        for (let i = 0; i < this.taluklist.length; i++)
        {
          if (this.taluklist[i].SUB_DIS_NAME == this.le.PMSUB_DIS_CODE) {
            let talukcode = this.taluklist[i].SUB_DIS_CODE;
            le.PMSUB_DIS_CODE=talukcode;
          }
        }
         
         //For Districtcode
         for (let i = 0; i < this.districtlist.length; i++) {
          if (this.districtlist[i].DIS_NAME == this.le.PMDIS_CODE) {
            let districtcode = this.taluklist[i].SUB_DIS_CODE;
            le.PMDIS_CODE=districtcode;
          }
        }
  
         //For Statecode
         for (let i = 0; i < this.statelist.length; i++) {
          if (this.statelist[i].ST_NAME == this.le.PMST_CODE) {
            let statecode = this.statelist[i].ST_CODE;
            le.PMST_CODE=statecode;
          }
        }
        le.pmC_CODE=1;

    if(le.CASTE_CODE==null||undefined)
        le.CASTE_CODE=1;   //1
    if(le.RELIGION_CODE==null||undefined)
    le.RELIGION_CODE=1;
    if(le.RES_CODE==null||undefined)
    le.RES_CODE=1;
    if(le.CUST_PRIVILEDGE==null||undefined)
    le.CUST_PRIVILEDGE=0;
    if(le.MARITALSTATUS==null||undefined)
    le.MARITALSTATUS=6
    if(le.CATG_CODE==null||undefined)
    le.CATG_CODE=6;
    if(le.OCCID==null||undefined)
    le.OCCID=1;
    if(le.ANNUALINCOME_1==null||undefined)
    le.ANNUALINCOME_1=0;
    if(le.EDUID==null||undefined)
    le.EDUID=1;
    if(le.BG==null||undefined)
    le.BG=1;
    if(le.CITY_OB==null||undefined)
    le.CITY_OB="-";
    if(le.MANUALNO==null||undefined)
    le.MANUALNO=0;
    if(le.PHONE==null||undefined)
    le.PHONE=0;

    le.comOFCODE=this.oadd;
    le.comRFCODE=this.radd;
    le.comPFCODE=this.padd;

    le.optPer= this.optPer;
    le.optOffice= this.optOffice;
    debugger;

    if((le.PMHouseNo ==undefined && le.PMDIS_ADD==undefined && le.PMANAME==undefined))
      le.presentaddres=false;
    else
     le.presentaddres=true;
    if(le.OABuildingNo==undefined && le.OADIS_ADD==undefined && le.OANAME==undefined)
     le.officeaddres=false;
    else
     le.value.officeaddres=true;


 this.GetMaxCustomerId(this.BRANCH_ID);
 //document.getElementById('loader-spinner').style.display = "block";
 le.Photo=this.getPhotoUrllegal();
 le.Signature=this.getSignatureUrllegal();
 for (let i = 0; i < this.lDocuments.length; i++) {
  le.CERT_ID=this.lDocuments[i].CERT_ID;
  le.LINKNO=this.lDocuments[i].LINKNO;
  le.LINKDATE=this.lDocuments[i].LINKDATE;
  le.profdoc=this.lDocuments[i].profdoc;
 }
debugger;
  le.DocumentModelsList= this.lDocuments;
  //le.CustomerType=this.c.CUSTTYPE;

  if(le!=null)
  {
    this.INDlegal.push(le);
    this.cancelmem();
    //this.le={};
    console.log("array");
    console.log(this.INDlegal);
    
  }
  else
  {

  }

}

}



// WEBPACK FOOTER //
// ./src/app/unicore-masters/customer-creation/customer-creation.component.ts